import { Component } from "solid-js";

interface WelcomeModalProps {
	isOpen: boolean;
	onClose: () => void;
}

const WelcomeModal: Component<WelcomeModalProps> = (props) => {
	return (
		<div
			class="fixed inset-0 z-50 flex items-center justify-center mb-12 md:mb-20"
			classList={{ hidden: !props.isOpen }}
		>
			<div class="rounded-lg shadow-xl py-8 md:py-10 px-6 md:px-12 max-w-md mx-4 text-center bg-white">
				<h1 class="text-xl font-bold ">Mordet på Olof Palme</h1>
				<p class="text-neutral-700 ">28 februari 1986</p>
				
				<p class="mt-6  text-neutral-600 text-[15px]">Följ händelseförloppet minut för minut. Tryck på "Play" för att starta simuleringen.</p>


				<button
					onClick={props.onClose}
					class="mt-6 px-5 py-1.5 text-sm bg-gray-800 hover:bg-gray-700 text-white rounded transition-colors"
				>
					OK
				</button>
			</div>
		</div>
	);
};

export default WelcomeModal;
